let loadingCount = 0;

export function showGlobalLoading() {
  loadingCount++;
  let dom = document.getElementById('global-loading');
  if (!dom) {
    dom = document.createElement('div');
    dom.id = 'global-loading';
    dom.style.cssText = `
      position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 9999;
      background: rgba(255,255,255,0.6); display: flex; align-items: center; justify-content: center;
      font-size: 20px; color: #1673FF;
    `;
    dom.innerHTML = `
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="20" stroke="#1673FF" stroke-width="4" opacity="0.2"/>
        <path d="M44 24c0-11.046-8.954-20-20-20" stroke="#1673FF" stroke-width="4" stroke-linecap="round">
          <animateTransform attributeName="transform" type="rotate" from="0 24 24" to="360 24 24" dur="1s" repeatCount="indefinite"/>
        </path>
      </svg>
    `;
    document.body.appendChild(dom);
  }
  dom.style.display = 'flex';
}

export function hideGlobalLoading() {
  loadingCount = Math.max(loadingCount - 1, 0);
  if (loadingCount === 0) {
    const dom = document.getElementById('global-loading');
    if (dom) dom.style.display = 'none';
  }
} 